export class PodConfigMinimal {
  id = 0;

  name = '';

  constructor(obj: any) {
    Object.assign(this, obj);
  }
}

export default PodConfigMinimal;
